export const HARVEST_EVENT_DOCUMENTS_LOAD_REQUESTED =
    'HARVEST_EVENT_DOCUMENTS_LOAD_REQUESTED';
export const HARVEST_EVENT_DOCUMENTS_LOAD_SUCCEEDED =
    'HARVEST_EVENT_DOCUMENTS_LOAD_SUCCEEDED';
export const HARVEST_EVENT_DOCUMENTS_LOAD_FAILED =
    'HARVEST_EVENT_DOCUMENTS_LOAD_FAILED';
export const HARVEST_EVENT_DOCUMENTS_LOAD_CANCELED =
    'HARVEST_EVENT_DOCUMENTS_LOAD_CANCELED';

export const HARVEST_EVENT_DOCUMENTS_SET = 'HARVEST_EVENT_DOCUMENTS';
